export default "__VITE_ASSET__26e162ce__"